import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Typography } from '@mui/material';

import { SelectableProps } from './types';

export type SelectableTableHeadProps<T> = SelectableProps['selectable'] & {
  idKey: keyof T;
  rows: T[];
};

export function SelectableTableHead<T>({
  handleToggleAll,
  idKey,
  rows,
  selectedIds,
  selectionActions,
}: SelectableTableHeadProps<T>) {
  const { t } = useTranslation();

  const rowIds = rows.map(item => item[idKey] as string);
  const isChecked = selectedIds.length > 0;
  const isIndeterminate = isChecked && !rowIds.every(id => selectedIds.includes(id));

  return (
    <Fragment>
      {handleToggleAll && (
        <Checkbox
          checked={isChecked}
          edge='start'
          indeterminate={isIndeterminate}
          onChange={({ target: { checked } }) =>
            isIndeterminate ? handleToggleAll(rowIds) : handleToggleAll(checked ? rowIds : [])
          }
        />
      )}

      <Typography color='inherit' component='div' sx={{ flex: '1 1 100%' }} variant='subtitle1'>
        {t('selected', { count: selectedIds.length })}
      </Typography>

      {selectionActions}
    </Fragment>
  );
}
